import { LogEntry, LogEnricher } from './types';
import { TraceContext } from './trace-context';
import { getTenantKey, getTenantId } from '../../services/utils';

export class TenantEnricher implements LogEnricher {
  enrich(_entry: LogEntry): Record<string, unknown> {
    return {
      tenant_key: getTenantKey(),
      tenant_id: getTenantId(),
    };
  }
}

export class EnvironmentEnricher implements LogEnricher {
  enrich(_entry: LogEntry): Record<string, unknown> {
    return {
      platform: 'web',
      environment: process.env.REACT_APP_STAGE || 'local',
      app_version: process.env.REACT_APP_VERSION || '0.0.0',
      user_agent: navigator.userAgent,
      pathname: window.location.pathname,
    };
  }
}

export class TraceEnricher implements LogEnricher {
  constructor(private traceContext: TraceContext) {}

  enrich(_entry: LogEntry): Record<string, unknown> {
    const result: Record<string, unknown> = {
      correlation_id: this.traceContext.getCurrentId(),
    };
    const op = this.traceContext.getCurrentOperation();
    if (op) result.operation = op;
    return result;
  }
}

export function applyEnrichers(
  entry: LogEntry,
  enrichers: LogEnricher[],
): Record<string, unknown> {
  return enrichers.reduce<Record<string, unknown>>(
    (acc, enricher) => ({ ...acc, ...enricher.enrich(entry) }),
    { ...entry },
  );
}
